import GoogleMapReact from 'google-map-react';
import googleMapReact from 'google-map-react';
import { LocationMarkerIcon } from '@heroicons/react/solid';

interface IGoogleMapProps extends googleMapReact.Props {
  children?: any;
  defaultZoom?: number;
}

const GoogleMap = ({
  children,
  defaultZoom = 6,
  ...props
}: IGoogleMapProps) => {
  return (
    <>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: 'AIzaSyA48aQrn851rBQKZfB3FK5E4iSw0LUDRXs',
          language: 'en',
        }}
        defaultZoom={defaultZoom}
        {...props}
      >
        {children ? (
          children
        ) : (
          <LocationMarkerIcon className='h-8 w-8 text-red-500' />
        )}
      </GoogleMapReact>
    </>
  );
};

export default GoogleMap;
